import { EventEmitter, Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, NgModule } from '@angular/core';
import { I18nTransKey, I18nModule } from 'b2c-ui/i18n';
import { ResponsiveService } from 'b2c-ui/core';
import { tap } from 'rxjs/operators';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { CommonModule } from '@angular/common';
import { NzButtonModule, NzGridModule } from 'ng-zorro-antd';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-safe-area.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'ng-zorro-antd';
import * as ɵngcc4 from 'b2c-ui/i18n';

function B2CSafeAreaComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.I18nTransKey == null ? null : ctx_r0.I18nTransKey.MOBILE_VIEW), " ");
} }
function B2CSafeAreaComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r1.I18nTransKey == null ? null : ctx_r1.I18nTransKey.DESKTOP_VIEW), " ");
} }
function B2CSafeAreaComponent_span_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r2.I18nTransKey == null ? null : ctx_r2.I18nTransKey.WEBSITE), " ");
} }
function B2CSafeAreaComponent_span_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r3.I18nTransKey == null ? null : ctx_r3.I18nTransKey.MOBILE_WEB), " ");
} }
function B2CSafeAreaComponent_span_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r4.I18nTransKey == null ? null : ctx_r4.I18nTransKey.MOBILE_WEB), " ");
} }
function B2CSafeAreaComponent_span_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r5.I18nTransKey == null ? null : ctx_r5.I18nTransKey.WEBSITE), " ");
} }
const _c0 = function (a0) { return { "isMobile": a0 }; };
class B2CSafeAreaComponent {
    /**
     * @param {?} responsiveService
     * @param {?} cdRef
     */
    constructor(responsiveService, cdRef) {
        this.responsiveService = responsiveService;
        this.cdRef = cdRef;
        this.I18nTransKey = I18nTransKey;
        this._isMobile = false;
        /**
         * Emit user's choice of View Change event
         */
        this.isChangeView = new EventEmitter();
    }
    /**
     * Set Mobile View
     * @param {?} value
     * @return {?}
     */
    set isMobile(value) {
        this._isMobile = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get isMobile() {
        return this._isMobile;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.responsiveService
            .isMobileWeb()
            .pipe(tap((/**
         * @param {?} mobile
         * @return {?}
         */
        (mobile) => {
            this.isMobile = mobile;
            console.log(this.isMobile);
            this.cdRef.markForCheck();
        })))
            .subscribe();
    }
    /**
     * @return {?}
     */
    onMaintain() {
        this.isChangeView.emit(false);
    }
    /**
     * @return {?}
     */
    onChange() {
        this.isChangeView.emit(true);
    }
}
B2CSafeAreaComponent.ɵfac = function B2CSafeAreaComponent_Factory(t) { return new (t || B2CSafeAreaComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
B2CSafeAreaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CSafeAreaComponent, selectors: [["b2c-safe-area"]], inputs: { isMobile: "isMobile" }, outputs: { isChangeView: "isChangeView" }, decls: 21, vars: 24, consts: [[1, "b2c-safe-area-blur"], [1, "b2c-safe-area", 3, "ngClass"], [1, "d-flex", "flex-column", "align-items-center", "justify-content-center"], ["nz-row", "", "nz-text", "", 1, "b2c-safe-area-text", "text-center", "mb-3", 3, "ngClass"], [4, "ngIf"], ["nzSize", "small", "nz-button", "", "nzType", "outline", 1, "b2c-safe-area-button", "mb-3", 3, "click"], ["nzSize", "small", "nz-button", "", "nzType", "primary", 1, "b2c-safe-area-button", 3, "click"]], template: function B2CSafeAreaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵpipe(5, "b2cI18n");
        ɵngcc0.ɵɵtemplate(6, B2CSafeAreaComponent_span_6_Template, 3, 3, "span", 4);
        ɵngcc0.ɵɵtemplate(7, B2CSafeAreaComponent_span_7_Template, 3, 3, "span", 4);
        ɵngcc0.ɵɵelement(8, "br");
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵpipe(10, "b2cI18n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "button", 5);
        ɵngcc0.ɵɵlistener("click", function B2CSafeAreaComponent_Template_button_click_11_listener() { return ctx.onMaintain(); });
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵpipe(13, "b2cI18n");
        ɵngcc0.ɵɵtemplate(14, B2CSafeAreaComponent_span_14_Template, 3, 3, "span", 4);
        ɵngcc0.ɵɵtemplate(15, B2CSafeAreaComponent_span_15_Template, 3, 3, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "button", 6);
        ɵngcc0.ɵɵlistener("click", function B2CSafeAreaComponent_Template_button_click_16_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵpipe(18, "b2cI18n");
        ɵngcc0.ɵɵtemplate(19, B2CSafeAreaComponent_span_19_Template, 3, 3, "span", 4);
        ɵngcc0.ɵɵtemplate(20, B2CSafeAreaComponent_span_20_Template, 3, 3, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(20, _c0, ctx.isMobile));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(22, _c0, ctx.isMobile));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 12, ctx.I18nTransKey == null ? null : ctx.I18nTransKey.SAFE_AREA_MESSAGE_1), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMobile);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isMobile);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 14, ctx.I18nTransKey == null ? null : ctx.I18nTransKey.SAFE_AREA_MESSAGE_2), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(13, 16, ctx.I18nTransKey == null ? null : ctx.I18nTransKey.CONTINUE_IN), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMobile);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isMobile);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(18, 18, ctx.I18nTransKey == null ? null : ctx.I18nTransKey.PROCEED_TO), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMobile);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isMobile);
    } }, directives: [ɵngcc2.NgClass, ɵngcc3.NzRowDirective, ɵngcc2.NgIf, ɵngcc3.NzButtonComponent], pipes: [ɵngcc4.B2CI18nPipe], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CSafeAreaComponent.ctorParameters = () => [
    { type: ResponsiveService },
    { type: ChangeDetectorRef }
];
B2CSafeAreaComponent.propDecorators = {
    isMobile: [{ type: Input }],
    isChangeView: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CSafeAreaComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-safe-area',
                template: "\r\n<div class='b2c-safe-area-blur'> </div>\r\n\r\n<div class='b2c-safe-area' [ngClass]=\"{'isMobile': isMobile}\">\r\n  <div class=\"d-flex flex-column align-items-center justify-content-center\">\r\n    <div nz-row nz-text class=\"b2c-safe-area-text text-center mb-3\" [ngClass]=\"{'isMobile': isMobile}\">\r\n      {{I18nTransKey?.SAFE_AREA_MESSAGE_1 | b2cI18n}} \r\n      <span *ngIf=\"isMobile\">{{I18nTransKey?.MOBILE_VIEW | b2cI18n}} </span>\r\n      <span *ngIf=\"!isMobile\">{{I18nTransKey?.DESKTOP_VIEW | b2cI18n}} </span> <br>\r\n      {{I18nTransKey?.SAFE_AREA_MESSAGE_2 | b2cI18n}}\r\n    </div>\r\n    <button class=\"b2c-safe-area-button mb-3\" nzSize=\"small\" nz-button nzType=\"outline\" (click)=\"onMaintain()\">\r\n      {{I18nTransKey?.CONTINUE_IN | b2cI18n}} \r\n      <span *ngIf=\"isMobile\">{{I18nTransKey?.WEBSITE | b2cI18n}} </span>\r\n      <span *ngIf=\"!isMobile\">{{I18nTransKey?.MOBILE_WEB | b2cI18n}} </span>\r\n    </button>\r\n    <button class=\"b2c-safe-area-button\" nzSize=\"small\" nz-button nzType=\"primary\" (click)=\"onChange()\">\r\n      {{I18nTransKey?.PROCEED_TO | b2cI18n}} \r\n      <span *ngIf=\"isMobile\">{{I18nTransKey?.MOBILE_WEB | b2cI18n}} </span>\r\n      <span *ngIf=\"!isMobile\">{{I18nTransKey?.WEBSITE | b2cI18n}} </span>\r\n    </button>\r\n  </div>\r\n</div>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc1.ResponsiveService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { isChangeView: [{
            type: Output
        }], isMobile: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    B2CSafeAreaComponent.prototype.I18nTransKey;
    /**
     * @type {?}
     * @private
     */
    B2CSafeAreaComponent.prototype._isMobile;
    /**
     * Emit user's choice of View Change event
     * @type {?}
     */
    B2CSafeAreaComponent.prototype.isChangeView;
    /**
     * @type {?}
     * @private
     */
    B2CSafeAreaComponent.prototype.responsiveService;
    /**
     * @type {?}
     * @private
     */
    B2CSafeAreaComponent.prototype.cdRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-safe-area.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CSafeAreaModule {
}
B2CSafeAreaModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CSafeAreaModule });
B2CSafeAreaModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CSafeAreaModule_Factory(t) { return new (t || B2CSafeAreaModule)(); }, imports: [[CommonModule, I18nModule, NzButtonModule, NzGridModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CSafeAreaModule, { declarations: function () { return [B2CSafeAreaComponent]; }, imports: function () { return [CommonModule, I18nModule, NzButtonModule, NzGridModule]; }, exports: function () { return [B2CSafeAreaComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CSafeAreaModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CSafeAreaComponent],
                exports: [B2CSafeAreaComponent],
                imports: [CommonModule, I18nModule, NzButtonModule, NzGridModule]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-safe-area.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CSafeAreaComponent, B2CSafeAreaModule };


//# sourceMappingURL=b2c-ui-safe-area.js.map